import type {
  ActionReputationDetailsType,
  CandidateReputationDetails,
} from '@axiom/validation';
import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';

class ActionReputationApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async createActionReputationDetails({
    reputationId,
    body,
  }: {
    reputationId: CandidateReputationDetails['id'];
    body: ActionReputationDetailsType;
  }) {
    return super.write<{ data: unknown }>({
      endpoint: `/actionReputationDetails/${reputationId}`,
      method: 'POST',
      body,
    });
  }

  async refreshActionReputationDetails({
    reputationId,
  }: {
    reputationId: CandidateReputationDetails['id'];
  }) {
    return super.invalidate(`/actionReputationDetails/${reputationId}`);
  }
}

export const ActionReputationApi = new ActionReputationApiClass();
